// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3Ad55","loaderOuter":"PageOverlayLoader_loaderOuter__23nHi"};